import { Menu } from "lucide-react";
import { useAppDrawerContext } from "../contexts/drawer.contexts";
import { ToastContainer } from "react-toastify";
import { ENVIRONMENT } from "../../environment/environment";
import { IconButton } from "../components/ui";

interface IBaseLayoutProps {
  title: string;
  children: React.ReactNode;
  barraDeFerramentas?: React.ReactNode;
}

export function BaseLayout({
  children,
  title,
  barraDeFerramentas,
}: IBaseLayoutProps) {
  const { toggleDrawerOpen } = useAppDrawerContext();

  return (
    <div className="relative flex h-screen w-full flex-col overflow-hidden bg-slate-50 dark:bg-slate-900">
      {/* Header fixo */}
      <header className="flex h-12 sm:h-[60px] lg:h-[77px] shrink-0 items-center gap-1 border-b border-slate-200 bg-white px-2 sm:px-5 dark:border-slate-700 dark:bg-slate-800">
        <IconButton className="lg:hidden" onClick={toggleDrawerOpen}>
          <Menu className="h-5 w-5" />
        </IconButton>

        <h1 className="truncate text-base font-semibold text-slate-900 sm:text-xl lg:text-2xl dark:text-white">
          {title}
        </h1>
      </header>

      {/* Barra de ferramentas fixa */}
      {barraDeFerramentas && (
        <div className="shrink-0 border-b border-slate-200 bg-slate-50 px-3 py-3 sm:px-5 dark:border-slate-700 dark:bg-slate-900">
          {barraDeFerramentas}
        </div>
      )}

      <ToastContainer />

      {/* Área de conteúdo com scroll */}
      <div className="relative mb-5 flex flex-1 flex-col overflow-hidden">
        <div className="custom-scrollbar h-full overflow-auto p-3 sm:p-5">
          {children}
        </div>
      </div>

      {/* Footer fixo */}
      <footer className="flex h-10 w-full shrink-0 items-center justify-center border-t border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800">
        <span className="text-[10px] leading-none text-slate-500 sm:text-xs dark:text-slate-400">
          v{ENVIRONMENT.REACT_APP_VERSION} - Build{" "}
          {ENVIRONMENT.REACT_APP_BUILD_DATE}
        </span>
      </footer>
    </div>
  );
}

